import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "@miro-site/core";
import theme from "./theme";
var TemplatesThemeProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsxs(ThemeProvider, {
        theme: function(defaultTheme) {
            return _object_spread({}, defaultTheme, theme);
        },
        children: [
            /*#__PURE__*/ _jsx(GlobalStyle, {}),
            children
        ]
    });
};
export default TemplatesThemeProvider;
